export const replaceWithSpan = (str) =>
  str.replace(/%([^%]+)%/g, "<span>$1</span>")

export const wrapEmojiWithSpan = (text) =>
  text.replace(
    /(\p{Emoji}|\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/gu,
    '<span class="emoji">$1</span>'
  )
